// Ignore module for browserify (see package.json)